import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { addNewHireContactRoute } from '../api/constants';
import { newHireContactList } from '../constants';

type useAddNewHireContactsProps = {
    setErrorText: Dispatch<SetStateAction<string>>;
};

export const useAddNewHireContacts = ({
    setErrorText,
}: useAddNewHireContactsProps) => {
    const client = useQueryClient();
    const { mutate: addNewHireContact, isLoading: isAddingNewHireContact } =
        useMutation({
            mutationFn: (variables: {
                email: string;
                name: string;
                company_name: string;
                company_id?: number;
            }) =>
                axiosInstance
                    .post(addNewHireContactRoute, variables)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status === 200) {
                    client.invalidateQueries([newHireContactList]);
                    setErrorText('');
                } else {
                    setErrorText(data?.message || errorMessage);
                }
            },
            onError: (error: { message?: string }) => {
                setErrorText(error?.message || errorMessage);
            },
        });

    return {
        addNewHireContact,
        isAddingNewHireContact,
    };
};
